import { put, call } from 'redux-saga/effects'
import { handleError, tariffService } from 'Services/ApiService.js'
import TariffActions from 'Stores/Tariff/Actions'
import { encodeObjectToBase64 } from '../Utils/base64functions'
import { IFToastMessage } from 'Components'
import { toaster } from 'rsuite'
import i18n from 'i18next'

export function* fetchTariffList({ filter, offset }) {
  if (offset == 0) {
    yield put(TariffActions.fetchTariffListLoading())
  } else {
    yield put(TariffActions.fetchTariffListLoadingMore())
  }
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(tariffService.get, `/me`, {
      params: {
        filter: filter,
        offset: offset,
      },
    })
    yield put(
      TariffActions.fetchTariffListSuccess(
        offset,
        data.tariffs,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(TariffActions.fetchTariffListFail())
    handleError(e)
  }
}
export function* createTariff({ tariff }) {
  yield put(TariffActions.createTariffLoading())
  try {
    const { data } = yield call(tariffService.post, `/`, tariff)
    yield put(TariffActions.createTariffSuccess(data))
    toaster.push(
      <IFToastMessage
        type="success"
        text={i18n.t('TariffModal.TariffToast')}
      />,
      {
        placement: 'topEnd',
      },
    )
  } catch (e) {
    yield put(TariffActions.createTariffFail())
    handleError(e)
  }
}
export function* updateTariff({ tariffID, tariff }) {
  yield put(TariffActions.updateTariffLoading())
  try {
    const { data } = yield call(
      tariffService.patch,
      `/${tariffID}`,
      tariff.tariff,
    )
    yield put(TariffActions.updateTariffSuccess(data))
    toaster.push(
      <IFToastMessage
        type="success"
        text={i18n.t('TariffModal.TariffUpdateToast')}
      />,
      {
        placement: 'topEnd',
      },
    )
  } catch (e) {
    yield put(TariffActions.updateTariffFail())
    handleError(e)
  }
}
export function* deleteTariff({ tariffID }) {
  yield put(TariffActions.deleteTariffLoading())
  try {
    yield call(tariffService.delete, `/${tariffID}`)
    yield put(TariffActions.deleteTariffSuccess(tariffID))
    toaster.push(
      <IFToastMessage
        type="success"
        text={i18n.t('TariffModal.TariffDeleteToast')}
      />,
      {
        placement: 'topEnd',
      },
    )
  } catch (e) {
    yield put(TariffActions.deleteTariffFail())
    handleError(e)
  }
}
export function* fetchTariffsCount({ filter }) {
  yield put(TariffActions.fetchTariffsCountLoading())
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(tariffService.get, `/count`, {
      params: {
        filter: filter,
      },
    })
    yield put(TariffActions.fetchTariffsCountSuccess(data.count))
  } catch (e) {
    yield put(TariffActions.fetchTariffsCountFail())
    handleError(e)
  }
}
